<script module lang="ts">
    import type { Product, WithContext } from 'schema-dts';
    import type { Variation } from '@shared/types/types';

    function jsonLdTag(obj: unknown) {
        const tag = 'script';
        return `<${tag} type="application/ld+json">${JSON.stringify(obj)}</${tag}>`;
    }

    export const generateJsonLD = (variation: Variation): WithContext<Product> => {
        const retailPriceValue = parseFloat(variation.price.retailPrice.replace('.', '').replace(',', '.'));

        const price = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            useGrouping: false,
        })
            .format(retailPriceValue)
            .replace('$', '')
            .trim();

        return {
            '@context': 'https:/*          */
            '@type': 'Product',
            name: variation.title.full,
            url: variation.detailPageLink,
            image: variation.images[0]?.jpeg ?? '',
            brand: {
                '@type': 'Brand',
                name: variation.brand,
            },
            additionalProperty: [
                {
                    '@type': 'PropertyValue',
                    name: 'variationId',
                    value: variation.variationId,
                },
            ],
            offers: [
                {
                    '@type': 'Offer',
                    itemCondition: 'https:/*                       */
                    availability: 'https:/*                  */
                    price,
                    priceCurrency: 'EUR',
                    url: variation.detailPageLink,
                },
            ],
            ...(variation.customerReviews && {
                aggregateRating: {
                    '@type': 'AggregateRating',
                    ratingValue: variation.customerReviews.averageRating,
                    reviewCount: variation.customerReviews.amount,
                },
            }),
        };
    };
</script>

<script lang="ts">
    interface Props {
        variation: Variation;
    }

    let { variation }: Props = $props();
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html jsonLdTag(generateJsonLD(variation))}
